export default __webpack_public_path__ + "static/media/metavet.2ebc77d6.png";